import useCashbackProgram from '../../hooks/cashback/useCashbackProgram';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import classnames from 'classnames';
import RewardIcon from '../../assets/logo/RewardIcon';
import useTheme from '../../hooks/ui/useTheme';
import { ButtonTypes } from '../../services/exports/Interfaces';
interface Props {
  amount: number;
  className?: string;
}

export default function EarnCashbackTag(props: Props) {
  const { amount, className } = props;

  const { t } = useTranslation(null, { keyPrefix: 'Components:Cashback:EarnCashbackTag' });
  const { hasCashbackProgram, calculateExpectedCashback } = useCashbackProgram();
  const theme = useTheme();

  const value = useMemo(() => calculateExpectedCashback(amount), [amount]);

  return (
    hasCashbackProgram &&
    value > 0 && (
      <div
        className={classnames(
          'bg-brand-button-primary-background/20 w-full py-xs px-md rounded-[8px] flex justify-center items-center relative',
          className,
        )}
      >
        <RewardIcon
          fill
          className="w-[14px] h-[14px]"
          color={theme.buttons[ButtonTypes.primary].text}
          backgroundColor={theme.buttons[ButtonTypes.primary].background}
        />
        <p className="text-sm font-medium text-center text-brand-primary mx-xs uppercase">
          {t('text', { count: value })}
        </p>
      </div>
    )
  );
}
